"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Customer = void 0;
const tslib_1 = require("tslib");
const DatastoreEnums_1 = require("../../src/types/DatastoreEnums");
const enumerableDecorator_1 = require("./constructs/enumerableDecorator");
const edgeTypeMatrixFns_1 = require("../classDependentTypes/EdgeTypes/edgeTypeMatrixFns");
const ModelTypes_1 = require("../types/ModelTypes");
const Organization_1 = require("./Organization");
const typeName = 'Customer';
const customerEdgeDefs = typeof edgeTypeMatrixFns_1.getAllEdgeDefinitionTypes === 'function' ? (0, edgeTypeMatrixFns_1.getAllEdgeDefinitionTypes)('Customer') : {};
const commonAttDefBase = {
    type: 'RelatedType',
    cardinality: {
        in: null,
        out: null,
    },
};
const commonAttDefsOut = {
    ...commonAttDefBase,
    direction: DatastoreEnums_1.PathDirection.child,
    objectTypeId: typeName,
};
const commonAttDefsIn = {
    ...commonAttDefBase,
    direction: DatastoreEnums_1.PathDirection.parent,
    objectTypeId: typeName,
};
class Customer extends Organization_1.Organization {
    constructor({ accountType, type, ...ob }) {
        super({ ...ob, type: type || typeName });
        this.conditionals = {};
        /** In the before times, customers had an account type that dictated what kinds of customers they could have underneath them and various abilities
         * e.g. ability to have users, add gateways, have devices (in a whole inventory system that is also no longer used)
         * 5 Jnue 2025 ADH - There are some old deprecated methods that do still rely on accountType (addCustomer and addGateway (I know they sound important but they actually aren't used anymore)). They now won't work unless accountType is explicitly set
         */
        if (accountType) {
            this.accountType = accountType;
        }
        if (this.canHaveSubCustomerTypeX()) {
            this.conditionals.Customer_SubCustomer_typeX = customerEdgeDefs.Customer_out_customer_has_subCustomer_typeX_Customer;
        }
        if (this.canHaveSubCustomerTypeY()) {
            this.conditionals.Customer_SubCustomer_typeY = customerEdgeDefs.Customer_out_customer_has_subCustomer_typeY_Customer;
        }
        if (this.canHaveSubCustomerTypeZ()) {
            this.conditionals.Customer_SubCustomer_typeZ = customerEdgeDefs.Customer_out_customer_has_subCustomer_typeZ_Customer;
        }
        if (this.canHaveParentCustomerTypeV()) {
            this.conditionals.Customer_ParentCustomer_typeV = customerEdgeDefs.Customer_in_customer_has_subCustomer_typeV_Customer;
        }
        if (this.canHaveParentCustomerTypeX()) {
            this.conditionals.Customer_ParentCustomer_typeX = customerEdgeDefs.Customer_in_customer_has_subCustomer_typeX_Customer;
        }
        if (this.canHaveParentCustomerTypeY()) {
            this.conditionals.Customer_ParentCustomer_typeY = customerEdgeDefs.Customer_in_customer_has_subCustomer_typeY_Customer;
        }
        if (this.canDefineServices()) {
            this.conditionals.ServiceOffering_define = {
                ...commonAttDefsIn,
                edgeTypeId: 'customer_defines_serviceOffering',
                //objectTypeId: 'ServiceOfferingDefinition',
                label: 'defines Service Offerings',
            };
        }
        if (this.canOfferServices()) {
            this.conditionals.ServiceOffering_offer = {
                ...commonAttDefsIn,
                edgeTypeId: 'customer_canOffer_serviceOffering',
                editable: false,
                //objectTypeId: 'ServiceOfferingDefinition',
                label: 'offers Service Offerings',
            };
        }
        if (this.canConsumeServices()) {
            this.conditionals.ServiceOffering_consume = {
                ...commonAttDefsIn,
                edgeTypeId: 'customer_canConsume_serviceOffering',
                editable: false,
                // objectTypeId: 'ServiceOfferingInstance',
                label: 'consumes Service Offerings',
            };
        }
        if (this.canHaveUsers()) {
            this.conditionals.Users = customerEdgeDefs.Customer_out_customer_has_users_User;
        }
        if (this.canHaveDeviceInventory()) {
            this.conditionals.DeviceInventory = customerEdgeDefs.Customer_out_customer_device_inventory_includes_Device;
        }
        if (this.canBeAllocatedDevices()) {
            this.conditionals.DeviceAllocation = customerEdgeDefs.Customer_out_customer_has_been_allocated_device_Device;
        }
        if (this.canManageGateways()) {
            this.conditionals.DeviceAllocation = customerEdgeDefs.Customer_out_customer_manages_gateway_Gateway;
        }
        if (this.canBeAllocatedGateways()) {
            this.conditionals.Gatewayllocation = customerEdgeDefs.Customer_out_customer_has_been_allocated_gateways_Gateway;
        }
    }
    /** @deprecated - Customer account types no longer used */
    canHaveSubCustomerTypeX() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.V, ModelTypes_1.CustomerAccountType.X].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canHaveSubCustomerTypeY() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.V, ModelTypes_1.CustomerAccountType.X, ModelTypes_1.CustomerAccountType.Y].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canHaveSubCustomerTypeZ() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.Y].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canHaveParentCustomerTypeV() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.X, ModelTypes_1.CustomerAccountType.Y].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canHaveParentCustomerTypeX() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.X, ModelTypes_1.CustomerAccountType.Y].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canHaveParentCustomerTypeY() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.Z].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canDefineServices() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.V].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canOfferServices() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.X, ModelTypes_1.CustomerAccountType.Y].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canConsumeServices() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.Y, ModelTypes_1.CustomerAccountType.Z].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canHaveUsers() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.V, ModelTypes_1.CustomerAccountType.X, ModelTypes_1.CustomerAccountType.Y, ModelTypes_1.CustomerAccountType.Z].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canHaveDeviceInventory() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.V].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canBeAllocatedDevices() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.X, ModelTypes_1.CustomerAccountType.Y, ModelTypes_1.CustomerAccountType.Z].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canManageGateways() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.V, ModelTypes_1.CustomerAccountType.X, ModelTypes_1.CustomerAccountType.Y].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canBeAllocatedGateways() {
        if (!this.accountType)
            return false;
        return [ModelTypes_1.CustomerAccountType.V, ModelTypes_1.CustomerAccountType.X, ModelTypes_1.CustomerAccountType.Y].includes(this.accountType);
    }
    /** @deprecated - Customer account types no longer used */
    canHaveSubCustomer(accountType) {
        switch (accountType) {
            case ModelTypes_1.CustomerAccountType.X:
                return [this.canHaveSubCustomerTypeX(), this.conditionals?.Customer_SubCustomer_typeX];
            case ModelTypes_1.CustomerAccountType.Y:
                return [this.canHaveSubCustomerTypeY(), this.conditionals?.Customer_SubCustomer_typeY];
            case ModelTypes_1.CustomerAccountType.Z:
                return [this.canHaveSubCustomerTypeZ(), this.conditionals?.Customer_SubCustomer_typeZ];
            default:
                return [false, undefined];
        }
    }
    /** @deprecated - Customer account types no longer used */
    canHaveParentCustomer(accountType) {
        switch (accountType) {
            case ModelTypes_1.CustomerAccountType.V:
                return [this.canHaveParentCustomerTypeV(), this.conditionals?.Customer_ParentCustomer_typeV];
            case ModelTypes_1.CustomerAccountType.X:
                return [this.canHaveParentCustomerTypeX(), this.conditionals?.Customer_ParentCustomer_typeX];
            case ModelTypes_1.CustomerAccountType.Y:
                return [this.canHaveParentCustomerTypeY(), this.conditionals?.Customer_ParentCustomer_typeY];
            default:
                return [false, undefined];
        }
    }
    /** @deprecated - Customer account types no longer used */
    canAllocateDeviceTo(accountType) {
        if (!this.accountType)
            return {
                [ModelTypes_1.CustomerAccountType.V]: true,
                [ModelTypes_1.CustomerAccountType.X]: true,
                [ModelTypes_1.CustomerAccountType.Y]: true,
                [ModelTypes_1.CustomerAccountType.Z]: true,
            };
        const ruleMatrix = {
            [ModelTypes_1.CustomerAccountType.V]: {
                [ModelTypes_1.CustomerAccountType.V]: false,
                [ModelTypes_1.CustomerAccountType.X]: true,
                [ModelTypes_1.CustomerAccountType.Y]: true,
                [ModelTypes_1.CustomerAccountType.Z]: false,
            },
            [ModelTypes_1.CustomerAccountType.X]: {
                [ModelTypes_1.CustomerAccountType.V]: false,
                [ModelTypes_1.CustomerAccountType.X]: true,
                [ModelTypes_1.CustomerAccountType.Y]: true,
                [ModelTypes_1.CustomerAccountType.Z]: false,
            },
            [ModelTypes_1.CustomerAccountType.Y]: {
                [ModelTypes_1.CustomerAccountType.V]: false,
                [ModelTypes_1.CustomerAccountType.X]: false,
                [ModelTypes_1.CustomerAccountType.Y]: true,
                [ModelTypes_1.CustomerAccountType.Z]: true,
            },
            [ModelTypes_1.CustomerAccountType.Z]: {
                [ModelTypes_1.CustomerAccountType.V]: false,
                [ModelTypes_1.CustomerAccountType.X]: false,
                [ModelTypes_1.CustomerAccountType.Y]: false,
                [ModelTypes_1.CustomerAccountType.Z]: false,
            },
        };
        return ruleMatrix[this.accountType][accountType];
    }
    /** @deprecated - Customer account types no longer used */
    canAllocateGatewayTo(accountType) {
        return this.canAllocateDeviceTo(accountType);
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            /** DEPRECATED FROM UI */
            /*
            ...this.conditionals,
            accountType: {
              enumKv: CustomerAccountType,
              type: 'Enum',
              editable: false,
            },
            */
        };
    }
}
exports.Customer = Customer;
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canHaveSubCustomerTypeX", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canHaveSubCustomerTypeY", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canHaveSubCustomerTypeZ", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canHaveParentCustomerTypeV", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canHaveParentCustomerTypeX", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canHaveParentCustomerTypeY", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canDefineServices", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canOfferServices", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canConsumeServices", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canHaveUsers", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canHaveDeviceInventory", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canBeAllocatedDevices", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canManageGateways", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", []),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canBeAllocatedGateways", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Object)
], Customer.prototype, "conditionals", void 0);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", Array)
], Customer.prototype, "canHaveSubCustomer", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", Array)
], Customer.prototype, "canHaveParentCustomer", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canAllocateDeviceTo", null);
tslib_1.__decorate([
    (0, enumerableDecorator_1.enumerable)(false),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String]),
    tslib_1.__metadata("design:returntype", void 0)
], Customer.prototype, "canAllocateGatewayTo", null);
